import React from 'react'
import { Route, Routes } from "react-router-dom"
import CrossDockingCreateScreen from "screens/App/CRM/CrossDocking/CrossDockingCreateScreen"
import CrossDockingDetailScreen from "screens/App/CRM/CrossDocking/CrossDockingDetailScreen"
import CrossDockingEditScreen from "screens/App/CRM/CrossDocking/CrossDockingEditScreen"
import CrossDockingListScreen from "screens/App/CRM/CrossDocking/CrossDockingListScreen"
import NotFoundScreen from "screens/NotFoundScreen"

const CrossDockingRouter = () => {
    return (
        <Routes>
            <Route path="create" element={<CrossDockingCreateScreen />} />

            <Route path="list" element={<CrossDockingListScreen />} />

            <Route path=":id/detail" element={<CrossDockingDetailScreen />} />

            <Route path=":id/edit" element={<CrossDockingEditScreen />} />

            <Route path="*" element={<NotFoundScreen />} />

        </Routes>
    )
}

export default CrossDockingRouter